import React from "react";
import styled from "styled-components";
import { lightThemeColors } from "../../assets/style/colors";
import { motion } from "framer-motion";
import PrimaryButton from "../generic/PrimaryButton";
import { Link } from "react-router-dom";
import OutlinedButton from "../generic/OutlinedButton";

const GetStartedRequestDemoSide = ({ title, subtitle, bgColor, gradientColor, gridDecoration, titleStyle, subtitleStyle, primaryButtonStyle, outlineButtonStyle, outlineButtonVariant, primaryButtonVariant }) => {
  return (
    <FullPageContainer bgColor={bgColor}>
      {gridDecoration &&
        <GridDecoration>
          {gridDecoration}
        </GridDecoration>

      }
      <Container id={"GetStartedRequestDemoSide"} >
        <BlurCircle blurColor={gradientColor} />
        <Line>
          <TextWrapper>
            <Title style={titleStyle}>{title}</Title>
            <Subtitle style={subtitleStyle}>{subtitle}</Subtitle>
            <Line>
              <PrimaryButton
                text={"Get Started"}
                styled={primaryButtonStyle}
                bgVariant={primaryButtonVariant}
                onClick={() =>
                  window.open("https://app.grovs.io/register", "_blank")
                }
              />

              <Link style={{ textDecoration: "none" }} to={"/contact"}>
                <OutlinedButton
                  style={outlineButtonStyle}
                  text={"Request a demo"}
                  variant={outlineButtonVariant}
                />
              </Link>
            </Line>
          </TextWrapper>
        </Line>
      </Container>
    </FullPageContainer>
  );
};

export default GetStartedRequestDemoSide;

const FullPageContainer = styled.div`
  display: flex;
  width: 100%;
  background: ${({ bgColor }) => bgColor ? bgColor : lightThemeColors.getStartedRequestDemoBackground};
  position: relative;
  overflow: hidden;
`;

const Container = styled.div`
  width: 100%;
  max-width: 1512px;
  margin-left: auto;
  margin-right: auto;
  z-index: 1;
  display: flex;
  flex-direction: column;
padding:100px 80px;
  gap: 100px;
  @media (max-width: 990px) {
    padding: 20px;
    gap: 30px;
  }
`;

const Title = styled.h1`
  color: ${lightThemeColors.darkColor};
  font-size: 36px;
  font-weight: 700;
  line-height: 46px;
  text-align: center;
  @media (max-width: 990px) {
    font-size: 30px;
    line-height: 36px;
    text-align: center;
  }
`;
const Subtitle = styled.p`
  color: ${lightThemeColors.darkColorFaded};
  font-size: 18px;
  font-weight: 400;
  line-height: 28px;
  text-align: center;
  @media (max-width: 990px) {
    font-size: 18px;
    line-height: 24px;
  }
`;
const TextWrapper = styled.div`
  display: flex;
  flex-direction: column;
  align-items: center;
  width: 100%;
  gap: 30px;
  max-width: 850px;
  margin: auto;
`;

const Line = styled(motion.div)`
  display: flex;
  align-items: center;
  gap: 25px;
    z-index: 2;
`;

const BlurCircle = styled.div`
  width: 500px;
  height: 100%;
  border-radius: 50%;
  background:${({ blurColor }) => blurColor};
  will-change: filter;
  filter: blur(120px);
  -webkit-filter: blur(120px);;
  position: absolute;
  opacity: 0.8;
  margin-left: auto;
  margin-right: auto;
  left: 0;
  top: 0;
  bottom: 0;
  right: 0;
  z-index: 1;
`;

const GridDecoration = styled.div`
  width: 100%;

  position: absolute;
  display: flex;
  top: 0;
  bottom: 0;
  left:0;
  align-items: center;
  svg {
  width:100%;

  }
`;